import axios from "axios";

export const state = {
    grades: [],
};

export const getters = {
    grades: state => state.grades,
};

export const mutations = {
    setGrading(state, newValue) {
        state.grades = newValue
    },
};

export const actions = {
    fetchGrades({ commit }) {
        axios.get('/nurserygrading').then(res => {
            commit('setGrading', res.data.grades);
        })
    },
};
